import { dataDashboardConstants as ddC } from "../constants/dataDashboard"

const initialState = {
  currentAssessment: {},
  compareAssessment: {},
  isSwap: false,
  isCompare: false,
  assessmentYear: "",
  testsData: {
    isFetchingExternalTestStudents: false,
    isFetchingExternalTests: false,
    storingStudentExternalTest: false,
    studentTestStoredSuccessfully: false,
    externalTestStudents: {},
    externalTests: {},
    testSubtypes: [
      { type: "", value: null, label: "---" },
      { type: "ACT", value: "ACT", label: "ACT" },
      { type: "ACT", value: "Pre-ACT", label: "Pre-ACT" },
      {
        type: "EOC",
        value: "LEAP 2025 Algebra I",
        label: "LEAP 2025 Algebra I"
      },
      {
        type: "EOC",
        value: "LEAP 2025 English II",
        label: "LEAP 2025 English II"
      },
      { type: "EOC", value: "EOC English III", label: "EOC English III" },
      { type: "EOC", value: "LEAP 2025 Geometry", label: "LEAP 2025 Geometry" },
      {
        type: "EOC",
        value: "LEAP 2025 U.S. History",
        label: "LEAP 2025 U.S. History"
      },
      { type: "EOC", value: "LEAP 2025 Biology", label: "LEAP 2025 Biology" },
      { type: "WorkKeys", value: "WorkKeys", label: "WorkKeys" }
    ]
  },
  externalSupports: {
    isFetchingExternalSupports: false,
    isFetchingAllStudentsExternalSupports: false,
    isDeletingStudentExternalSupport: false,
    deletingAllStudentsExternalSupports: false,
    addingAllStudentsExternalSupports: false,
    isAddingStudentExternalSupport: false,
    externalSupportsList: {},
    externalSupportStudents: {},
    externalSupportGroups: {}
  },
  groupETs: {},
  studentAllETs: {},
  fetchingStudentETs: false
}

export function dataDashboard(state = initialState, action) {
  switch (action.type) {
    case ddC.ADD_ALL_STUDENTS_EXTERNAL_SUPPORT:
      return {
        ...state,
        externalSupports: {
          ...state.externalSupports,
          addingAllStudentsExternalSupports: true
        }
      }
    case ddC.ADD_ALL_STUDENTS_EXTERNAL_SUPPORT_SUCCESS:
      return {
        ...state,
        externalSupports: {
          ...state.externalSupports,
          externalSupportStudents: {
            ...state.externalSupports.externalSupportStudents,
            ...action.payload
          },
          addingAllStudentsExternalSupports: false
        }
      }
    case ddC.ADD_ALL_STUDENTS_EXTERNAL_SUPPORT_ERROR:
      return {
        ...state,
        externalSupports: {
          ...state.externalSupports,
          addingAllStudentsExternalSupports: false
        }
      }

    case ddC.DELETE_ALL_STUDENTS_EXTERNAL_SUPPORTS:
      return {
        ...state,
        externalSupports: {
          ...state.externalSupports,
          deletingAllStudentsExternalSupports: true
        }
      }
    case ddC.DELETE_ALL_STUDENTS_EXTERNAL_SUPPORTS_SUCCESS:
      return {
        ...state,
        externalSupports: {
          ...state.externalSupports,
          deletingAllStudentsExternalSupports: false,
          externalSupportStudents: {}
        }
      }
    case ddC.DELETE_ALL_STUDENTS_EXTERNAL_SUPPORTS_ERROR:
      return {
        ...state,
        externalSupports: {
          ...state.externalSupports,
          deletingAllStudentsExternalSupports: false
        }
      }

    case ddC.DELETE_STUDENT_EXTERNAL_SUPPORT:
      return {
        ...state,
        externalSupports: {
          ...state.externalSupports,
          isDeletingStudentExternalSupport: true
        }
      }
    case ddC.DELETE_STUDENT_EXTERNAL_SUPPORT_ERROR:
      return {
        ...state,
        externalSupports: {
          ...state.externalSupports,
          isDeletingStudentExternalSupport: false
        }
      }
    case ddC.DELETE_STUDENT_EXTERNAL_SUPPORT_SUCCESS:
      return {
        ...state,
        externalSupports: {
          ...state.externalSupports,
          externalSupportStudents: { ...action.payload },
          isDeletingStudentExternalSupport: false
        }
      }
    case ddC.FETCH_ALL_STUDENTS_EXTERNAL_SUPPORT:
      return {
        ...state,
        externalSupports: {
          ...state.externalSupports,
          isFetchingAllStudentsExternalSupports: true
        }
      }
    case ddC.FETCH_ALL_STUDENTS_EXTERNAL_SUPPORT_SUCCESS:
      return {
        ...state,
        externalSupports: {
          ...state.externalSupports,
          isFetchingAllStudentsExternalSupports: false,
          externalSupportStudents: action.payload
        }
      }
    case ddC.FETCH_ALL_STUDENTS_EXTERNAL_SUPPORT_ERROR:
      return {
        ...state,
        externalSupports: {
          ...state.externalSupports,
          isFetchingAllStudentsExternalSupports: false
        }
      }
    case ddC.FETCH_EXTERNAL_SUPPORTS_GROUPS:
      return {
        ...state,
        externalSupports: {
          ...state.externalSupports,
          isFetchingExternalSupportsGroups: true
        }
      }
    case ddC.FETCH_EXTERNAL_SUPPORTS_GROUPS_SUCCESS:
      return {
        ...state,
        externalSupports: {
          ...state.externalSupports,
          isFetchingExternalSupportsGroups: false,
          externalSupportGroups: {
            ...state.externalSupports.externalSupportGroups,
            ...action.payload
          }
        }
      }
    case ddC.FETCH_EXTERNAL_SUPPORTS_GROUPS_ERROR:
      return {
        ...state,
        externalSupports: {
          ...state.externalSupports,
          isFetchingExternalSupportsGroups: false
        }
      }
    case ddC.ADD_STUDENT_EXTERNAL_SUPPRORT:
      return {
        ...state,
        externalSupports: {
          ...state.externalSupports,
          isAddingStudentExternalSupport: true
        }
      }
    case ddC.ADD_STUDENT_EXTERNAL_SUPPRORT_ERROR:
      return {
        ...state,
        externalSupports: {
          ...state.externalSupports,
          isAddingStudentExternalSupport: false
        }
      }
    case ddC.ADD_STUDENT_EXTERNAL_SUPPRORT_SUCCESS:
      return {
        ...state,
        externalSupports: {
          ...state.externalSupports,
          isAddingStudentExternalSupport: false,
          externalSupportStudents: {
            ...state.externalSupports.externalSupportStudents,
            [action.payload.id]: action.payload
          }
        }
      }
    case ddC.FETCH_EXTERNAL_SUPPORT:
      return {
        ...state,
        externalSupports: {
          ...state.externalSupports,
          isFetchingExternalSupports: true
        }
      }
    case ddC.FETCH_EXTERNAL_SUPPORT_SUCCESS:
      return {
        ...state,
        externalSupports: {
          ...state.externalSupports,
          isFetchingExternalSupports: false,
          externalSupportsList: action.payload
        }
      }
    case ddC.FETCH_EXTERNAL_SUPPORT_ERROR:
      return {
        ...state,
        externalSupports: {
          ...state.externalSupports,
          isFetchingExternalSupports: false
        }
      }
    case ddC.STORE_EXTERNAL_TESTS_STUDENT:
      return {
        ...state,
        testsData: {
          ...state.testsData,
          storingStudentExternalTest: true,
          studentTestStoredSuccessfully: false
        }
      }
    case ddC.STORE_EXTERNAL_TESTS_STUDENT_SUCCESS:
      return {
        ...state,
        testsData: {
          ...state.testsData,
          storingStudentExternalTest: false,
          studentTestStoredSuccessfully: true
        }
      }

    case ddC.STORE_EXTERNAL_TESTS_STUDENT_ERROR:
      return {
        ...state,
        testsData: {
          ...state.testsData,
          studentTestStoredSuccessfully: false,
          storingStudentExternalTest: false
        }
      }
    case ddC.FETCH_EXTERNAL_TESTS_BY_SUBTYPE:
      return {
        ...state,
        testsData: {
          ...state.testsData,
          isFetchingExternalTests: true
        }
      }
    case ddC.FETCH_EXTERNAL_TESTS_BY_SUBTYPE_ERROR:
      return {
        ...state,
        testsData: {
          ...state.testsData,
          isFetchingExternalTests: false
        }
      }
    case ddC.FETCH_EXTERNAL_TESTS_BY_SUBTYPE_SUCCESS:
      return {
        ...state,
        testsData: {
          ...state.testsData,
          externalTests: {
            ...state.testsData.externalTests,
            [action.payload.slug]: action.payload.result
          },
          isFetchingExternalTests: false
        }
      }
    case ddC.CHANGE_ASSESSMENT_ID:
      return {
        ...state,
        currentAssessment: action.value
      }
    case ddC.CHANGE_EXIT_TICKET_ID:
      return {
        ...state,
        compareAssessment: action.value
      }
    case ddC.CHANGE_COMPARE_MODE:
      return {
        ...state,
        isCompare: action.value
      }
    case ddC.CHANGE_SWAP:
      return {
        ...state,
        isSwap: action.value
      }
    case ddC.CHANGE_YEAR:
      return {
        ...state,
        assessmentYear: action.value
      }

    case ddC.GET_EXTERNAL_TEST_GROUP:
      return {
        ...state,
        loadingExternalTestGroup: true
      }

    case ddC.GET_EXTERNAL_TEST_GROUP_SUCCESS:
      return {
        ...state,
        groupETs: { ...state.groupETs, ...action.data },
        loadingExternalTestGroup: false
      }

    case ddC.GET_EXTERNAL_TEST_GROUP_FAILURE:
      return {
        ...state,
        loadingExternalTestGroup: false,
        externalTestGroupError: action.error
      }

    case ddC.UPDATE_EXTERNAL_TEST_GROUP:
      return {
        ...state,
        updatingExternalTestGroup: true
      }

    case ddC.UPDATE_EXTERNAL_TEST_GROUP_SUCCESS:
      return {
        ...state,
        groupETs: { ...state.groupETs, ...action.data },
        updatingExternalTestGroup: false
      }

    case ddC.UPDATE_EXTERNAL_TEST_GROUP_FAILURE:
      return {
        ...state,
        updatingExternalTestGroup: false,
        updateExternalTestGroupError: action.error
      }

    case ddC.UPDATE_EXTERNAL_SUPPORT_GROUP:
      return {
        ...state,
        updatingExternalSupportGroup: true
      }

    case ddC.UPDATE_EXTERNAL_SUPPORT_GROUP_SUCCESS:
      return {
        ...state,
        externalSupports: {
          ...state.externalSupports,
          externalSupportGroups: {
            ...state.externalSupportGroups,
            ...action.data
          }
        },
        updatingExternalSupportGroup: false
      }

    case ddC.UPDATE_EXTERNAL_SUPPORT_GROUP_FAILURE:
      return {
        ...state,
        updatingExternalSupportGroup: false
      }
    case ddC.GET_ALL_EXTERNAL_TEST:
      return {
        ...state,
        fetchingETs: true,
        fetchingETsError: ""
      }
    case ddC.GET_ALL_EXTERNAL_TEST_SUCCESS:
      return {
        ...state,
        fetchingETs: false,
        externalTests: action.data
      }
    case ddC.GET_ALL_EXTERNAL_TEST_FAILURE:
      return {
        ...state,
        fetchingETs: false,
        fetchingETsError: action.error
      }
    case ddC.GET_EXTERNAL_TEST_STUDENT:
      return {
        ...state,
        fetchingStudentETs: true
      }

    case ddC.GET_EXTERNAL_TEST_STUDENT_SUCCESS:
      return {
        ...state,
        studentAllETs: { studentId: action.studentId, ETs: action.studentETs },
        fetchingStudentETs: false
      }

    case ddC.GET_EXTERNAL_TEST_STUDENT_FAILURE:
      return {
        ...state,
        fetchingStudentETs: false,
        externalTestsStudentError: action.error
      }
    default:
      return state
  }
}
